import moment from "moment";
import { api_auth, api_host } from "../../common/globals/constants";

export async function getDetalleDisponibilidadParcialObjetivoDowntime(
    groups = [],
    periodState
) {
    try {
        const token = sessionStorage.getItem("key") || "";
        const user_id = sessionStorage.getItem("user") || "";

        const fecha_inicio = periodState?.statePeriod?.startDate
            ? moment(periodState.statePeriod.startDate).format("YYYY-MM-DD")
            : null;
        const fecha_termino = periodState?.statePeriod?.endDate
            ? moment(periodState.statePeriod.endDate).format("YYYY-MM-DD")
            : null;

        const isCustomPeriod = periodState?.period === "c";
        const endpoint = isCustomPeriod
            ? "getDetalleDisponibilidadParcialObjetivoDowntimeCustom"
            : "getDetalleDisponibilidadParcialObjetivoDowntime";

        const results = await Promise.allSettled(
            groups.map(async (service) => {
                const queryParams = new URLSearchParams({
                    user: user_id,
                    key: api_auth || "",
                    objetivoId: service.objetivo_id ?? "",
                    horarioId: "0",
                    t: periodState?.period || "",
                    token: token,
                    nodoId: "0"
                });

                if (isCustomPeriod && fecha_inicio && fecha_termino) {
                    queryParams.append("fechaInicio", fecha_inicio);
                    queryParams.append("fechaTermino", fecha_termino);
                }

                const url = `${api_host}/reporte/online/indicadores/${endpoint}/?${queryParams.toString()}`;

                const response = await fetch(url);
                if (!response.ok) {
                    throw new Error(`HTTP ${response.status} en objetivoId: ${service.objetivo_id}`);
                }

                const json = await response.json();
                
                // Mantenemos las propiedades del servicio original y sobreescribimos con la respuesta
                return { ...service, ...json };
            })
        );

        const successful = [];
        const pending = [];

        results.forEach((res, index) => {
            if (res.status === "fulfilled") {
                successful.push(res.value);
            } else {
                pending.push(groups[index]);
            }
        });

        return { successful, pending };

    } catch (err) {
        console.error("Error en getDetalleDisponibilidadParcialObjetivoDowntime:", err);
        return { successful: [], pending: groups };
    }
}